import { definePreset } from '@primeng/themes';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { XFARM_PRESET } from './themes/xfarm-preset';

export const XFarmPreset = definePreset(Aura, XFARM_PRESET);

export function providePrimeNGConfig() {
  return providePrimeNG({
    theme: {
      preset: XFarmPreset,
      options: {
        darkModeSelector: '.p-dark',
      },
    },
  });
}
